import { render, staticRenderFns } from "./ResourceOverview.vue?vue&type=template&id=fce73846&scoped=true"
import script from "./ResourceOverview.vue?vue&type=script&lang=js"
export * from "./ResourceOverview.vue?vue&type=script&lang=js"
import style0 from "./ResourceOverview.vue?vue&type=style&index=0&id=fce73846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce73846",
  null
  
)

export default component.exports